import { List } from "immutable";
/**
 * Splits a List<T> into two List<T>'s based on the given predicate
 * 
 * @param list - List of elements to be partitions based on predicate
 * @param predicate - Predicate that determines if a given element is placed in the first or second partition
 * @returns An array whose first element contains a List<T> for which `predicate` is true and the second element a List<T> for which `predicate` is false
 */ export const partition = (list, predicate)=>list.reduce((param, element)=>{
        let [predicateTrue, predicateFalse] = param;
        return predicate(element) ? [
            predicateTrue.push(element),
            predicateFalse
        ] : [
            predicateTrue,
            predicateFalse.push(element)
        ];
    }, [
        List(),
        List()
    ]);
const smallViewPortThreshold = 1024;
export const isSmallViewport = ()=>window.innerWidth < smallViewPortThreshold;
export const prefixedLog = (prefix)=>function(message) {
        for(var _len = arguments.length, tail = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            tail[_key - 1] = arguments[_key];
        }
        return console.log(`[${prefix}] ${message}`, tail);
    };
